export var removeSplash = function() {
	if ( $('.hide-on-pagin, .hide-splash').length > 0 && window.location.hash.length > 0){
		var urlHash = window.location.hash.split('&');
		if(urlHash.length > 1){
			var urlBeginIndex = urlHash[1].split('=')[1];
			var urlFacetNewArrival = urlHash.indexOf('facet=1000149');

			if (urlBeginIndex !== 'undefined' && urlBeginIndex !== '0' ){
				$('.hide-on-pagin, .hide-splash').hide();
			} else if ( urlFacetNewArrival > -1 ) {
				//Remove .hide-on-pagin if seperation of business logic is required
				$('.hide-on-pagin, .hide-splash').hide();
			}else{
				$('.hide-on-pagin, .hide-splash').show();
			}
			if(String(window.location.hash).indexOf("facet=") > -1){ 
				$('.hide-on-pagin, .hide-splash').hide();
			}
		}
	} else if ( $('.hide-on-pagin, .hide-splash').length > 0 && window.location.hash.length == 0){
		$('.hide-on-pagin, .hide-splash').show(); 
	}
};
